import { defineMessages } from 'react-intl';
import addAndRemoveObjectsFromArray from '../../../helpers/addAndRemoveObjectsFromArray';

import Default from './Default';
import Thumbnails from './Thumbnails';
import ImageList from './ImageList';
import DownloadList from './DownloadList';
// import GroupedByDate from './GroupedByDate';

const messages = defineMessages({
  newsVariation: {
    id: 'Images',
    defaultMessage: 'Images',
  },
  groupedByDateVariation: {
    id: 'Grouped by date',
    defaultMessage: 'Grouped by date',
  },
  default: {
    id: 'Default',
    defaultMessage: 'Default',
  },
  thumbnails: {
    id: 'Thumbnails',
    defaultMessage: 'Thumbnails',
  },
  imageList: {
    id: 'Image list',
    defaultMessage: 'Image list',
  },
  downloadList: {
    id: 'Download list',
    defaultMessage: 'Download list',
  },
  hideImagesTitles: {
    id: 'Hide images titles',
    defaultMessage: 'Hide images titles',
  },
  hideImagesDates: {
    id: 'Hide images dates',
    defaultMessage: 'Hide images dates',
  },
});

const removedDefaultVariations = ['default', 'summary', 'imageGallery'];

const listingVariations = [
  {
    id: 'default',
    isDefault: true,
    title: 'Default',
    template: Default,
  },
  {
    id: 'thumbnails',
    isDefault: false,
    title: 'Thumbnails',
    template: Thumbnails,
  },
  {
    id: 'dowlodList',
    isDefault: false,
    title: 'Download list',
    template: DownloadList,
  },
  {
    id: 'imageList',
    isDefault: false,
    title: 'Image list',
    template: ImageList,
    pageSize: 12,
    schemaEnhancer: ({ schema, intl }) => {
      schema.fieldsets.push({
        id: 'layout',
        title: 'layout',
        fields: ['hideTitles', 'hideDates'],
      });
      // schema.fieldsets[0].fields.push('hideTitles');
      schema.properties.hideTitles = {
        title: intl.formatMessage(messages.hideImagesTitles),
        required: false,
        default: false,
        type: 'boolean',
      };
      schema.properties.hideDates = {
        title: intl.formatMessage(messages.hideImagesDates),
        required: false,
        default: false,
        type: 'boolean',
      };
      //schema.properties.href.selectedItemAttrs.push("CreationDate");
      return schema;
    },
  },

  // {
  //   id: 'groupedByDate',
  //   isDefault: false,
  //   title: 'Grouped by date',
  //   template: GroupedByDate,
  // },
];

const applyConfig = (config) => {
  config.blocks.blocksConfig.listing.variations = addAndRemoveObjectsFromArray(
    config.blocks.blocksConfig.listing.variations,
    listingVariations,
    removedDefaultVariations,
  );

  return config;
};

export default applyConfig;
